import React from 'react'

export default function Headers({title}) {
  return (
    <h2 className="mt-3 mb-3 display-2">{title}</h2>
  )
}
